import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { AlertTriangle, CalendarClock, CheckCircle2 } from "lucide-react";

export default function Scadenze() {
  const [alerts, setAlerts] = useState(null);
  const [days, setDays] = useState(30);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/expiry-alerts", { params: { days } }).then((r) => setAlerts(r.data));
  }, [days]);

  const expired = (alerts || []).filter((a) => a.status === "expired");
  const expiring = (alerts || []).filter((a) => a.status === "expiring");

  return (
    <div data-testid="scadenze-page">
      <PageHeader title="Avvisi Scadenze" subtitle="Visite mediche e certificati scaduti o in scadenza">
        <div className="flex items-center gap-2">
          {[30, 60, 90].map((d) => (
            <button
              key={d}
              data-testid={`days-${d}`}
              onClick={() => setDays(d)}
              className={`px-3 py-2 border font-head uppercase tracking-wide text-xs font-bold transition-colors ${
                days === d ? "bg-rugby-yellow text-black border-rugby-yellow" : "border-border text-muted-foreground hover:text-white"
              }`}
            >
              {d} gg
            </button>
          ))}
        </div>
      </PageHeader>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
        <div className="border border-rugby-red/40 bg-rugby-red/5 p-5 flex items-center gap-4">
          <AlertTriangle className="h-8 w-8 text-rugby-red" />
          <div>
            <div className="font-head font-bold text-3xl leading-none text-rugby-red">{expired.length}</div>
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-muted-foreground mt-1">Scaduti</div>
          </div>
        </div>
        <div className="border border-amber-500/40 bg-amber-500/5 p-5 flex items-center gap-4">
          <CalendarClock className="h-8 w-8 text-amber-400" />
          <div>
            <div className="font-head font-bold text-3xl leading-none text-amber-400">{expiring.length}</div>
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-muted-foreground mt-1">In scadenza ({days} gg)</div>
          </div>
        </div>
      </div>

      {alerts === null ? (
        <div className="text-muted-foreground p-8">Caricamento...</div>
      ) : alerts.length === 0 ? (
        <div className="border border-border bg-card p-12 text-center">
          <CheckCircle2 className="h-10 w-10 text-emerald-400 mx-auto mb-4" />
          <p className="text-muted-foreground">Nessuna scadenza entro {days} giorni. Tutto in regola.</p>
          <p className="text-xs text-muted-foreground/70 mt-2">
            Le scadenze si basano sui campi "Scadenza visita" e "Scadenza C.I." delle schede atleta.
          </p>
        </div>
      ) : (
        <div className="border border-border bg-card overflow-hidden">
          <div className="hidden md:grid grid-cols-[1.5fr_1.2fr_1.2fr_1fr_1fr] gap-4 px-5 py-3 border-b border-border bg-[#0b0b0b] text-[10px] uppercase tracking-[0.2em] font-bold text-muted-foreground">
            <div>Atleta</div>
            <div>Tipo</div>
            <div>Scadenza</div>
            <div>Giorni</div>
            <div>Stato</div>
          </div>
          {alerts.map((a, i) => (
            <div
              key={`${a.athlete_id}-${a.type}-${i}`}
              data-testid={`alert-row-${a.athlete_id}`}
              onClick={() => navigate(`/atleti/${a.athlete_id}`)}
              className="grid grid-cols-2 md:grid-cols-[1.5fr_1.2fr_1.2fr_1fr_1fr] gap-2 md:gap-4 px-5 py-4 border-b border-border last:border-b-0 cursor-pointer hover:bg-white/5 transition-colors items-center"
            >
              <div>
                <span className="font-head font-semibold uppercase text-sm">{a.cognome}</span>{" "}
                <span className="text-muted-foreground text-sm">{a.nome}</span>
              </div>
              <div className="text-sm text-muted-foreground">{a.type}</div>
              <div className="font-mono text-sm">{a.date}</div>
              <div className="font-mono text-sm">
                {a.days_left < 0 ? `${Math.abs(a.days_left)} fa` : `tra ${a.days_left}`}
              </div>
              <div>
                {a.status === "expired" ? (
                  <span className="text-[10px] font-bold uppercase px-2 py-1 border border-rugby-red/40 text-rugby-red bg-rugby-red/10">Scaduto</span>
                ) : (
                  <span className="text-[10px] font-bold uppercase px-2 py-1 border border-amber-500/40 text-amber-400 bg-amber-500/10">In scadenza</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
